import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { WorkingService } from '../../service';

@Component({
  selector: 'app-working',
  templateUrl: './working.component.html',
  styleUrls: ['./working.component.scss']
})
export class WorkingComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.setParentStyle();
  }

  @Input() id: string;

  @Input()
  set blockUI(blockUI: boolean) {
    this.element.nativeElement
      .setAttribute('class', blockUI
        ? 'block-ui'
        : '');
  }

  constructor(
    @Optional() @Inject(DOCUMENT) private document: Document,
    private element: ElementRef,
    private working: WorkingService
  ) { }

  ngOnInit(): void {
    this.setParentStyle();
  }

  private setParentStyle(): void {
    const parent = (<HTMLElement>this.element.nativeElement).parentElement;
    // ensure container has a style position set
    if (parent
      && !this.getStyle(parent, 'position')) {
      parent.style.position = 'relative';
      console.log(parent.style.position);
    }
  }

  private getStyle(element: HTMLElement, prop: string): string {
    return element['currentStyle']
      || window.getComputedStyle
      ? this.document.defaultView
        .getComputedStyle(element, null)
        .getPropertyValue(prop)
      : null;
  }

}
